<template>
  <div
    class="text warp"
    :class="[
      'text-' + datas.textPos,
      { 'show-more': datas.showMore },
      'terminal' + datas.terminal,
    ]"
    :style="{ backgroundColor: datas.bgColor }"
  >
    <div class="line-warp" :class="{ borderBot: datas.showLine }">
      <div class="scroll-container" ref="container">
        <div class="scroll-content">
          <div style="display: flex; overflow-x: auto">
            <h3 class="h3" v-for="(item, index) in datas.title" :key="index">
              {{ item.text }}
            </h3>
          </div>
        </div>
      </div>

      <!-- <div>
        <van-tabs background="black" :active-color="''" line-width="0px" style="border-radius: 10px;" class="left-aligned-tabs">
          <van-tab gutter="10px"  v-for="(item,index) in componentContent.title" :key="index" :title="item.text" >
             内容 {{ index }}
          </van-tab>
      </van-tabs>
      </div> -->
      <p
        class="p"
        :style="{
          fontSize: datas.describeSizeNum + 'px',
          fontWeight: datas.describeFontW,
          color: datas.describeColor,
        }"
      >
        {{ datas.describe }}
      </p>
      <div
        class="btn-more"
        v-show="datas.showMore"
        :class="'style' + datas.styleValue"
        @click="jumpLink(item.linkObj)"
      >
        <span>查看更多</span><i class="iconfont icon-arrow-right"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "entertheshop",
  props: {
    datas: Object,
  },
  data() {
    return {};
  },
  mounted() {
    // const container = this.$refs.container;
    // let startX = 0;
    // let isScrolling = false;
    // container.addEventListener('touchstart', (e) => {
    //   startX = e.touches[0].pageX;
    //   isScrolling = false;
    // });
    // container.addEventListener('touchmove', (e) => {
    //   const currentX = e.touches[0].pageX;
    //   const scrollLeft = container.scrollLeft;
    //   const distance = startX - currentX;
    //   if (!isScrolling) {
    //     isScrolling = true;
    //     if (Math.abs(distance) > 10) {
    //       container.style.overflowX = 'scroll'; // 显示滚动条
    //     }
    //   }
    //   if (isScrolling) {
    //     e.preventDefault(); // 阻止默认的滑动事件
    //     container.scrollLeft = scrollLeft + distance;
    //   }
    // });
    // container.addEventListener('touchend', () => {
    //   container.style.overflowX = 'hidden'; // 隐藏滚动条
    // });
  },
};
</script>

<style lang="scss" scoped>
/* 容器样式，设置为可横向滚动 */
.scroll-container {
  width: 100%; /* 设置容器宽度 */
  overflow: hidden; /* 隐藏滚动条 */
}

/* 内容样式，设置内容的宽度 */
.scroll-content {
  width: 1000px; /* 设置内容宽度 */
  /* 添加其他内容样式 */
  white-space: nowrap; /* 防止内容折行 */
}
// ::v-deep .van-tabs__nav--line{
//   border-radius: 5px;
// }
// ::v-deep .van-tabs__nav {
//   justify-content: flex-start;
// }
// ::v-deep .van-tab--active{
//   background: red !important;
//   border-bottom: none !important;
// }

// ::v-deep .van-tab__text--ellipsis{
//   background: $dynamicColor !important;
// }
// ::v-deep .van-tab__text{
//   background: $dynamicColor !important;
// }
.van-tab {
  margin-right: 10px;
}
.text {
  padding: 0px 20px;
  position: relative;
  .line-warp {
    padding: 10px 0;
  }
  .borderBot {
    border-bottom: 1px solid #cccc;
  }
  .h3 {
    line-height: 1.5;
    margin-left: 20px;
  }
  .p {
    line-height: 1.5;
    margin-top: 5px;
  }
  .style1 {
  }
  .style2 {
    .iconfont {
      display: none;
    }
  }
  .style3 {
    span {
      display: none;
    }
  }
  &.text-left {
    text-align: left;
    &.show-more {
      position: relative;
      padding-right: 20px;
      .btn-more {
        position: absolute;
        right: 0;
        top: 10px;
      }
    }
  }
  &.text-center {
    text-align: center;
  }
  &.text-right {
    text-align: right;
  }
}
</style>
